import { render, staticRenderFns } from "./FrequentQuestionsComponent.vue?vue&type=template&id=8b3b0536"
import script from "./FrequentQuestionsComponent.vue?vue&type=script&lang=js"
export * from "./FrequentQuestionsComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports